module.exports = __webpack_public_path__ + "img/BfA_Lue.4b7bce36.png";